module.exports = __webpack_public_path__ + "img/delete.d169364d.svg";